import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * ── 为什么这里要 extend 而不是直接用 twMerge ──────────────────
 *
 * tailwind-merge 的活是「同一组里后写的赢」。它认得 Tailwind 自带的
 * `text-sm`(字号)和 `text-slate-500`(颜色)分属两组,但对工厂端那套自定义
 * token(`text-portal-body` / `text-portal-ink`)它两个都认不出来 ——
 * 认不出来的 `text-*` 一律归到颜色组,于是
 *
 *     cn('text-portal-display font-semibold text-portal-ink', 'max-w-[16ch]')
 *       →  text-portal-ink max-w-[16ch]        ← 字号被吃掉了
 *
 * 症状是**整页标题静默塌回默认字号**:class 名还在源码里,浏览器里没有,
 * 用例也抓不到(vitest 里 Tailwind 根本不生效)。第一版登录页就是这样,
 * 截出来一看 h1 跟正文一样大才发现。
 *
 * 所以把两套自定义 token 明确告诉 tailwind-merge。以后往
 * `tailwind.config.mjs` 里加 `portal-*` 的颜色或字号,**这里要同步加一行**,
 * 否则又会静默塌一次。
 */
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [
        {
          text: [
            'portal-meta',
            'portal-caption',
            'portal-body',
            'portal-lg',
            'portal-h3',
            'portal-h2',
            'portal-h1',
            'portal-display',
          ],
        },
      ],
      'text-color': [
        {
          text: [
            'portal-ink',
            'portal-ink2',
            'portal-char',
            'portal-mute',
            'portal-accent',
            'portal-accent-hover',
            'portal-ok',
            'portal-warn',
            'portal-danger',
            'portal-info',
            'portal-wechat',
          ],
        },
      ],
    },
  },
});

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
